export type EulaGateRefs = {
  gate: HTMLElement;
  appShell: HTMLElement;
  content: HTMLElement;
  acceptCheckbox: HTMLInputElement;
  acceptButton: HTMLButtonElement;
  declineButton: HTMLButtonElement;
};

export type EulaGateOptions = {
  eulaHtml: string;
  hasAccepted: () => boolean;
  onAccept: () => void;
  onAccepted: () => void;
  onDecline: () => void;
};

export function setupEulaGate(refs: EulaGateRefs, options: EulaGateOptions): void {
  refs.content.innerHTML = options.eulaHtml;

  let activated = false;

  const activateUpdater = (): void => {
    if (activated) {
      return;
    }
    activated = true;
    refs.gate.hidden = true;
    refs.appShell.hidden = false;
    options.onAccepted();
  };

  const syncAcceptButton = (): void => {
    refs.acceptButton.disabled = !refs.acceptCheckbox.checked;
  };

  refs.acceptCheckbox.checked = false;
  syncAcceptButton();

  refs.acceptCheckbox.addEventListener('change', syncAcceptButton);
  refs.acceptButton.addEventListener('click', () => {
    if (activated || refs.acceptButton.disabled) {
      return;
    }
    options.onAccept();
    activateUpdater();
  });

  refs.declineButton.addEventListener('click', () => {
    options.onDecline();
  });

  if (options.hasAccepted()) {
    activateUpdater();
    return;
  }

  refs.gate.hidden = false;
  refs.appShell.hidden = true;
}
